import { formatDistanceToNow, format } from 'date-fns'

export const formatFileSize = (bytes: number | null) => {
    if (!bytes && bytes !== 0) return '-'
    const units = ['B', 'KB', 'MB', 'GB']
    let size = bytes
    let unitIndex = 0
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex++
    }
    return `${size.toFixed(1)} ${units[unitIndex]}`
}

export const formatNumber = (num: number | null) => {
    if (num === null || num === undefined) return '-'
    return new Intl.NumberFormat('en-US').format(num)
}

export const formatElapsedTime = (startDate: string) => {
    if (!startDate) return '-'
    return formatDistanceToNow(new Date(startDate), { addSuffix: true })
}

export const formatJoinDate = (dateString: string) => {
    if (!dateString) return ''
    return `Joined ${format(new Date(dateString), 'MMMM yyyy')}`
}
